import swal from "sweetalert2";
<template lang="html">
  <div>
    <b-col md="12">
      <b-card>
        <div class="table-responsive-sm">
          <table class="table b-table table-striped" style="margin-bottom:0px">
              <tbody class="">
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="80" style="background-color:#f1f1f1">
                      <label class="col-form-label">대분류</label>
                    </td>
                    <td class="">
                      <b-form-select id="basicSelect" v-model="reportPopSearchData.top_type_code"
                        :plain="true"
                        :options="searchTopDepths"
                        v-on:change="selectSubOptionResult()"
                        :value="null">
                      </b-form-select>
                    </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="80" style="background-color:#f1f1f1">
                      <label class="col-form-label">소분류</label>
                    </td>
                    <td class="">
                      <b-form-select id="basicSelect" v-model="reportPopSearchData.type_code" :disabled="subOptionCheck"
                        :plain="true"
                        :options="searchSubDepths"
                        :value="null">
                      </b-form-select>
                    </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="80" style="background-color:#f1f1f1">
                      <label class="col-form-label">카테고리</label>
                    </td>
                    <td class="" colspan="4">
                      <b-row class="pt-sm-12">
                        <b-col sm="12">
                          <b-button size="sm" class="mx-1" v-show="categoryButtonOptions.length > 0"
                          variant="outline-primary"
                          v-for="(categoryBtn, idx) in categoryButtonOptions"
                          :key="idx"
                          :pressed.sync="categoryBtn.state"
                          >
                            {{ categoryBtn.item_name }}
                          </b-button>
                        </b-col>
                      </b-row>
                    </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="80" style="background-color:#f1f1f1">
                    <label class="col-form-label">등록일</label>
                  </td>
                  <td class="">
                    <b-row class="pt-sm-12">
                      <b-col sm="4"><b-form-input type="text" name="datepicker" :disabled="reportPopSearchData.day_code == 'dayall'" /></b-col>
                      <b-col sm="8">
                        <b-button class="mx-1"
                        variant="outline-primary"
                        v-for="(dateMonthBtn, idx) in popDateMonthButtons"
                        v-on:click="dateMonthSelect(dateMonthBtn)"
                        :key="idx"
                        :pressed.sync="dateMonthBtn.state"

                        >
                          {{ dateMonthBtn.item_name }}
                        </b-button>
                      </b-col>
                    </b-row>
                  </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="80" style="background-color:#f1f1f1">
                    <label class="col-form-label">키워드</label>
                  </td>
                  <td class="">
                    <b-row class="pt-sm-12">
                      <b-col sm="12"><b-form-input id="basicText" type="text" v-model="reportPopSearchData.keyword" v-on:keyup="$event.keyCode === 13 ? findDrReportOptList() : ''" placeholder="보고서명 및 옵션명을 입력해주세요."></b-form-input></b-col>
                    </b-row>
                  </td>
                </tr>
              </tbody>
          </table>
          <div style="float:right; padding:5px">
            <b-button type="submit" variant="primary" v-on:click="findDrReportOptList()"> 검색</b-button>
          </div>
        </div>
      </b-card>


      <b-card style="padding:0px">
        <div style="background-color: black;width: 100%;height: 100%;display: block;position: absolute;left: 0px;top: 0px; opacity: 0.2" v-on:click="pkgRowsData = []; $refs.pkgTable.refresh()" v-show="pkgRowsData.length > 0">
          <p style="width: 100%;height: 100%;display: block;position: absolute;left: 35%;top: 37%; color:#ffffff; font-weight:bold; font-size:20px">패키지 포함 목록 선택중</p>
        </div>
        <div slot="header">콘텐츠관리 - 모든 보고서 옵션 목록 (총 {{reportOptions.optItems.length}}건)</div>
        <div class="opt-table">
          <b-table style="margin-bottom:0px"
            striped
            hover
            bordered
            selectable
            ref="optTable"
            :select-mode="selectMode"
            selectedVariant="success"
            :fields="fieldItems"
            :items="reportOptions.optItems"
            :busy="reportOptions.optItems == 0"
            @row-selected="optSelected">
            <div slot="table-busy" class="text-center my-2">
              <strong>데이터가 없습니다.</strong>
            </div>
          </b-table>
        </div>
      </b-card>
    </b-col>

    <div class="card" style="border: 0px; margin:-23px 0 -5px 0">
    	<div class="card-body" style="padding: 0px">
    		<div style="margin: 0px auto; display: block; width: 55%">
    			<p style="float: left; font-size: 55px" :style="optRowsData.length > 0 ? 'opacity: 0.2' : (optRowsData.length == 0 && pkgRowsData.length == 0) ? 'opacity: 0.2': ''">
            <!-- 주옵션으로 이동 -->
    				<a href="javascript:void(0)" v-on:click="optOptionsGo()" v-show="(optRowsData.length > 0 && pkgRowsData.length > 0) || (optRowsData.length == 0 && pkgRowsData.length > 0)"><i class="fa fa-hand-o-up fa-lg mt-4"></i></a>
            <i class="fa fa-hand-o-up fa-lg mt-4" v-show="optRowsData.length > 0 || (optRowsData.length == 0 && pkgRowsData.length == 0)"></i>
    			</p>
    			<p style="float: right; font-size: 55px" :style="pkgRowsData.length > 0 ? 'opacity: 0.2' : (optRowsData.length == 0 && pkgRowsData.length == 0) ? 'opacity: 0.2': ''">
            <!-- 패키지로 이동 -->
    				<a href="javascript:void(0)" v-on:click="pkgOptionsGo()" v-show="(optRowsData.length > 0 && pkgRowsData.length > 0) || (pkgRowsData.length == 0 && optRowsData.length > 0)"><i class="fa fa-hand-o-down fa-lg mt-4"></i></a>
            <i class="fa fa-hand-o-down fa-lg mt-4" v-show="pkgRowsData.length > 0  || (optRowsData.length == 0 && pkgRowsData.length == 0)"></i>
    			</p>
    		</div>
    	</div>
    </div>

    <b-col md="12">
      <b-card style="padding:0px">
        <div style="background-color: black;width: 100%;height: 100%;display: block;position: absolute;left: 0px;top: 0px; opacity: 0.2" v-on:click="optRowsData = []; $refs.optTable.refresh()" v-show="optRowsData.length > 0">
          <p style="width: 100%;height: 100%;display: block;position: absolute;left: 37%;top: 37%; color:#ffffff; font-weight:bold; font-size:20px">주옵션 목록 선택중</p>
        </div>
        <div slot="header">패키지 포함 목록</div>
        <div class="opt-table">
          <b-table style="margin-bottom:0px"
            striped
            hover
            bordered
            selectable
            ref="pkgTable"
            :select-mode="selectMode"
            selectedVariant="success"
            :fields="fieldItems"
            :items="reportOptions.pkgItems"
            :busy="reportOptions.pkgItems == 0"
            @row-selected="pkgSelected">
            <div slot="table-busy" class="text-center my-2">
              <strong>데이터가 없습니다.</strong>
            </div>
          </b-table>
        </div>
      </b-card>
    </b-col>

  </div>
</template>

<script>
import { codeAPI } from '../../common/code.js';
import _ from 'lodash';
import swal from 'sweetalert2'

export default {
  props: {
    reportOptions:{
      optItems: [],
      pkgItems: [],
      pkgOptList: []
    },
    formModal:null,
  },
  data(){
    return {
      reportPopSearchData: {
        day_code: 'dayall',
        top_type_code: 'all',
        type_code: 'all',
        start_date: '',
        end_date: '',
      },
      subOptionCheck: true,
      selectMode: 'multi',
      selectTopTypeItems: [],
      selectTypeItems: [],
      searchTopDepths: [],
      searchSubDepths: [],
      categoryButtonOptions: [],
      optRowsData: [],
      pkgRowsData: [],
      popDateMonthButtons: [
        { item_name: '전체', item_code:'dayall', state: true },
        { item_name: '오늘', item_code:'1|days',state: false },
        { item_name: '1주일', item_code:'7|days',state: false },
        { item_name: '1개월', item_code:'1|months',state: false },
        { item_name: '6개월', item_code:'6|months',state: false },
        { item_name: '1년', item_code:'1|years',state: false },
      ],
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
      fieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center'
        }
      }, {
        'report_name': {
          'label': '보고서 명',
          'class': 'text-left'
        }
      }, {
        'opt_code': {
          'label': '옵션코드',
          'class': 'text-center'
        }
      }, {
        'name': {
          'label': '옵션명',
          'class': 'text-center'
        }
      }, {
        'reg_date': {
          'label': '등록일',
        }
      }],
    }
  },
  mounted: function() {
    var self = this;
    var token = sessionStorage.getItem("myToken");
    var codeItemDatas = [];
    var resultDatas = [];
    var depthXItems = [];

    codeAPI.selectItemCodeList(self,"RPT_TYPE",2,"selectTopTypeItems");
    // codeAPI.selectItemCodeList(self,"RPT_TYPE_2",3,"selectTypeItems");
    setTimeout(function(){
      resultDatas.push({text: '전체',value: 'all'});
      self.selectTopTypeItems.forEach(function (el, idx, arr){
        var items = {
          text: el.item_name,
          value: el.item_code,
        };
        resultDatas.push(items);
      });
      self.searchTopDepths = resultDatas;
      self.searchSubDepths.push({text: '전체',value: 'all'});
      self.reportPopSearchData.top_type_code = 'all';
      self.reportPopSearchData.type_code = 'all';
    }, 500);

    // codeAPI.selectItemCodeList(self,"RPT_TYPE_2",3,"selectTypeItems");
    // setTimeout(function(){
    //   resultDatas.push({text: '전체',value: 'all'});
    //   self.selectTypeItems.forEach(function (el, idx, arr){
    //     var items = {
    //       text: el.item_name,
    //       value: el.item_code,
    //     };
    //     resultDatas.push(items);
    //   });
    //   self.searchSubDepths = resultDatas;
    //   console.log(self.searchSubDepths);
    //   self.reportPopSearchData.type_code = self.searchSubDepths[0].value;
    // }, 500);


    self.$http.get('/api/select/itemCodeList?access_token='+ token +'&parentCode=RPT_CATE')
    .then((result) => {
      var categoryDatas = result.data;
      categoryDatas.forEach(function (el, idx, arr){
        el.state = false;
      });
      self.categoryButtonOptions = categoryDatas;
    })

    $(function() {
      $('input[name="datepicker"]').daterangepicker({
        opens: 'left',
        "locale": self.calendarLocale,
        "endDate": moment().format('YYYY-MM-DD'),
        "startDate": moment().add(0, 'days').format('YYYY-MM-DD')
      }, function(start, end, label) {
        self.reportPopSearchData.start_date = start.format('YYYY-MM-DD');
        self.reportPopSearchData.end_date = end.format('YYYY-MM-DD');
      });
    });
  },
  watch: {
    formModal () {
      var self = this;
      self.optRowsData = [];
      self.pkgRowsData = [];
      self.$refs.optTable.refresh();
      self.$refs.pkgTable.refresh();
      // console.log(self.reportOptions);
      if(self.formModal){
        self.reportOptions.optItems.forEach(function (el, idx, arr){
          el.rnum = (idx+1);
        });
      }
    },
  },
  methods:{
    // 메소드명 : findDrReportList()
    // ### 리포트 조회 ###
    // 리포트를 DB테이블에서 조회한다.
    //
    // 최초작성 : 2016.06.27
    // 파라미터 :
    //  - parentCode(그룹코드 값)
    //  - depth(대분류,소분류 구분)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.06.27  황경현   최초작성
    // *************************
    findDrReportOptList() {
      var self = this;
      var categoryParams = [];
      self.categoryButtonOptions.forEach(function (el, idx, arr){
        var categoryData = {
          cate_code: el.item_code
        }
        if(el.state){
          categoryParams.push(categoryData);
        }
      });
      self.reportPopSearchData.categoryitems = categoryParams;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.reportPopSearchData));

      var data = new FormData();
      data.append('optObjs', param);

      self.$http.post('/api/select/drReportSearchOptList?access_token=' + token, data, null)
        .then((result) => {
          self.reportOptions.optItems = result.data;
          self.reportOptions.optItems.forEach(function (el, idx, arr){
            el.rnum = (idx+1);
          });
        })
    },
    optSelected(items) {
      this.optRowsData = items;
    },
    pkgSelected(items) {
      this.pkgRowsData = items;
    },
    optOptionsGo() {
      var self = this;
      self.pkgRowsData.forEach(function (el, idx, arr){
        self.reportOptions.pkgItems.forEach(function (t_el, t_idx, t_arr){
          if(el.opt_code == t_el.opt_code){
            self.reportOptions.pkgItems.splice(t_idx, 1);
          }
        });
        self.reportOptions.optItems.push(el);
      });
    },
    pkgOptionsGo() {
      var self = this;
      self.optRowsData.forEach(function (el, idx, arr){
        self.reportOptions.optItems.forEach(function (t_el, t_idx, t_arr){
          if(el.opt_code == t_el.opt_code){
            self.reportOptions.optItems.splice(t_idx, 1);
          }
        });

        if(_.some( self.reportOptions.pkgItems, {opt_code : el.opt_code} )){
          swal.fire({
            title: '패키지 옵션 설정 중복',
            html: "중복된 보고서 입니다",
            type: 'warning',
          })
        }else {
          self.reportOptions.pkgItems.push(el);
        }
      });
    },
    dateMonthSelect (item) {
      var self = this;
      self.popDateMonthButtons.forEach(function (el, idx, arr){
        if(el.item_code == item.item_code){
          el.state = true;
        }else{
          el.state = false;
        }
      });
      // { item_name: '전체', item_code:'dayall', state: true },
      // { item_name: '오늘', item_code:'1|days',state: false },
      // { item_name: '1주일', item_code:'7|days',state: false },
      // { item_name: '1개월', item_code:'1|months',state: false },
      // { item_name: '6개월', item_code:'6|months',state: false },
      // { item_name: '1년', item_code:'1|years',state: false },
      self.reportPopSearchData.day_code = item.item_code;
      var addDateCnt = 0;
      var dateSpilt;
      dateSpilt = item.item_code.split("|");
      setTimeout(function(){
        $('input[name="datepicker"]').data('daterangepicker').setStartDate(moment().format('YYYY-MM-DD'));
  		  $('input[name="datepicker"]').data('daterangepicker').setEndDate(moment().add(dateSpilt[0], dateSpilt[1]).format('YYYY-MM-DD'));
        self.reportPopSearchData.start_date = moment().format('YYYY-MM-DD');
        self.reportPopSearchData.end_date = moment().add(dateSpilt[0], dateSpilt[1]).format('YYYY-MM-DD');
      }, 0);
    },
    selectSubOptionResult() {
      var self = this;
      var resultDatas = [];
      self.subOptionCheck = true;
      if(self.reportPopSearchData.top_type_code != "all"){
        codeAPI.selectItemCodeList(self,self.reportPopSearchData.top_type_code,3,"selectTypeItems");
        setTimeout(function(){
          resultDatas.push({text: '전체',value: 'all'});
          self.selectTypeItems.forEach(function (el, idx, arr){
            var items = {
              text: el.item_name,
              value: el.item_code,
            };
            resultDatas.push(items);
          });
          self.searchSubDepths = resultDatas;
          self.reportPopSearchData.type_code = self.searchSubDepths[0].value;
          self.subOptionCheck = false;
        }, 500);
      }else{
        self.reportPopSearchData.type_code = 'all';
      }
    }
  }
}
</script>


<style scoped>
.formLabel{
  font-weight: 600;
}
.opt-table {
  max-height: 278px;
  overflow: auto;
}
.card-body {
  padding:0px
}
</style>



// WEBPACK FOOTER //
// src/views/product/ReportOptModal.vue